import { SubscriptionOptionEnum } from "@shared_packages/toolkit/types";
import { AppRoutes } from "../../../../constants/routes";
import { isDeletedSubscriptionStatus } from "../components/subscriptionBillingTabs.config";

/**
 * What the EU payments tab shows for a regular company is decided by its EU
 * Payments Only subscription, never by the company flag: the flag and the
 * enabled currencies are a projection written when that subscription goes
 * live. Partner-managed companies hold no subscription, so for them the flag
 * switch stays the whole gate.
 */
export type EuPaymentsCompanyInput = {
  subscriptions?: Array<{
    subscriptionOption?: string;
    status?: string;
  }> | null;
  enabledOpenBankingPaymentCurrencies?: string[] | null;
  canAccessInternationalOb?: boolean | null;
};

export type EuPaymentsState =
  | { kind: "none" }
  | { kind: "preconfigured"; status: string }
  | { kind: "live"; status: string };

export function resolveEuPaymentsState(
  company: EuPaymentsCompanyInput | null | undefined
): EuPaymentsState {
  const euSubs = (company?.subscriptions ?? []).filter(
    (sub) =>
      sub.subscriptionOption === SubscriptionOptionEnum.PAYMENTS_ONLY_EU &&
      !isDeletedSubscriptionStatus(sub.status)
  );
  if (!euSubs.length) return { kind: "none" };
  const live = euSubs.find(
    (sub) => (sub.status ?? "").toLowerCase() !== "incomplete"
  );
  if (live) return { kind: "live", status: live.status ?? "active" };
  return { kind: "preconfigured", status: "incomplete" };
}

/** EU payment currencies on the company, upper-cased, GBP left out. */
export function euPaymentCurrencies(
  company: EuPaymentsCompanyInput | null | undefined
): string[] {
  return Array.from(
    new Set(
      (company?.enabledOpenBankingPaymentCurrencies ?? [])
        .map((currency) => String(currency).trim().toUpperCase())
        .filter((currency) => currency && currency !== "GBP")
    )
  );
}

export function subscriptionsTabPath(companyId: string): string {
  return `${AppRoutes.Private.Companies.DETAILS}${companyId}/${AppRoutes.Private.CompanyDetailsSection.BILLING_SUBSCRIPTIONS}`;
}
